module.exports = __webpack_public_path__ + "media/images/receipt/cancelled_order-8f91eeb8148ba422e2e4ca503d66aebd.png";